import { useState } from "react";
import Box from "@mui/material/Box";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { useT } from "../../shared/i18n";
import { GalleryBrowse } from "./GalleryBrowse";
import { GalleryAppearanceSearch } from "./GalleryAppearanceSearch";

type GalleryMode = "browse" | "appearance";

/**
 * The gallery: all photos by default (browse), with a separate "by appearance"
 * mode that ranks photos against a free-text description using the server-
 * produced image embeddings mirrored to the client (ticket 09). Text search in
 * the app bar stays unaffected.
 */
export function GalleryView() {
  const t = useT();
  const [mode, setMode] = useState<GalleryMode>("browse");

  return (
    <Box>
      <ToggleButtonGroup
        value={mode}
        exclusive
        onChange={(_, v: GalleryMode | null) => { if (v) setMode(v); }}
        size="small"
        sx={{ mb: 2 }}
        aria-label={t("galleryMode")}
      >
        <ToggleButton value="browse">{t("galleryModeBrowse")}</ToggleButton>
        <ToggleButton value="appearance">{t("galleryModeAppearance")}</ToggleButton>
      </ToggleButtonGroup>

      {mode === "browse" ? <GalleryBrowse /> : <GalleryAppearanceSearch />}
    </Box>
  );
}
